import React, {useContext, useEffect, useState} from "react";
import CustomPopup from "../../../../components/CustomPopup";
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import './CreateWordDialog.css'
import {isEmptyOrNullOrUndefined} from "../../../../common/utils/Datautil.ts";
import {ToastContext} from "../../../../components/CustomToast/ToastProvider.tsx";
import {apiService} from "../../../../common/utils/http/api-service.ts";
import debounce from "lodash/debounce";
import useLoading from "../../../../providers/loadingContext/useLoading.ts";
import {ICreateUgc} from "../../../../common/utils/http/IParams.ts";

interface Props {
    isOpen: boolean,
    onClose: () => void,
}

// Join Match弹窗
const CreateWordDialog: React.FC<Props> = ({isOpen, onClose}) => {
        // 主题管理器
        const {imgUrls} = useContext(ThemeContext);
        const placeHoldText = "Your word";
        const {addToast} = useContext(ToastContext);
        const {showLoading, hideLoading} = useLoading();
        // word
        const [word, setWord] = useState<string>('');
        // hint
        const [hint, setHint] = useState<string>('');
        // 提示语最多只能输入的单词数量
        const maxHintLength = 200;

        // 提交
        const handleSubmit = debounce(async () => {
            // word 和 hint 都不能为空
            if (isEmptyOrNullOrUndefined(word) || isEmptyOrNullOrUndefined(hint)) {
                addToast({
                    type: 'error',
                    message: 'Please fill in the word and hint'
                });
                return;
            }
            try {
                showLoading("Waiting for AI review", undefined, false)
                const param: ICreateUgc = {
                    word,
                    hint
                }
                const response = await apiService.createUGCWord(param)
                if (response.code === 200) {
                    addToast({
                        type: 'success',
                        message: response.message
                    })
                    onClose()
                } else {
                    addToast({
                        type: 'error',
                        message: response.message
                    })
                }
            } finally {
                hideLoading()
            }
        }, 100)

        // 处理word的编辑
        const handleWordEdit = (e: React.ChangeEvent<HTMLInputElement>) => {
            // 值拷贝单词
            const copyWord = e.target.value.slice();
            if (copyWord.length > 5) {
                addToast({
                    type: "error",
                    message: "The word cannot be more than 5 letters."
                })
                return;
            }

            if (copyWord.length > 0) {
                // 判断输入的是不是字母，只能输入英文单词
                if (!/^[a-zA-Z]+$/.test(copyWord)) {
                    addToast({
                        type: "error",
                        message: "Please enter a valid word!",
                    });
                    return;
                }
            }

            // 大写
            const newWord = copyWord.toUpperCase();

            setWord(newWord);
        };

        // 处理hint的编辑
        const handleHintEdit = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
            const hintCopy = e.target.value.slice();
            if (hintCopy.length > maxHintLength) {
                addToast({
                    type: "error",
                    message: `The hint cannot be more than ${maxHintLength} letters.`
                })
                return;
            }
            setHint(hintCopy);
        }

        useEffect(() => {
            if (!isOpen) {
                setWord('')
                setHint('')
            }
        }, [isOpen]);


        return (
            <CustomPopup isOpen={isOpen} onClose={onClose}>
                <div className="create-word-modal-container">
                    <img className="common-dialog-embellish-bg-left-top" src={imgUrls.leftTopBgDialogUrl} alt="pic"/>
                    <img className="common-dialog-embellish-bg-right-bottom" src={imgUrls.rightBottomBgDialogUrl}
                         alt="pic"/>
                    {/*标题*/}
                    <div
                        className="font-size-16 my-roboto-bold text-center margin-top-14 height-26 display-flex-row display-flex-justify-content-center display-flex-align-items-center">
                        Create Your Own Puzzle!
                        <img onClick={onClose} src={imgUrls.closerBtnGreyUrl} className="exit-close-btn"
                             alt="pic"/>
                    </div>
                    {/*单词输入框*/}
                    <div className="width-260 height-43 margin-top-27 margin-left-right-auto">
                        <input placeholder={placeHoldText}
                               type={"text"}
                               value={word}
                               onChange={handleWordEdit}
                               className={`text-area-border font-size-16 my-roboto-regular padding-left-14 padding-right-14 text-ellipsis  color-black-custom width-260 height-43 bg-color-grey-input  border-radius-5 margin-left-right-auto display-flex-row display-flex-align-items-center`}/>
                    </div>
                    {/*提示语*/}
                    <div className="margin-left-26 margin-top-6 font-size-13  my-roboto-regular color-red">
                        * Enter a five-letter word!
                    </div>
                    {/*hint内容框*/}
                    <div className="position-relative margin-top-6 margin-left-right-auto width-260 height-145">
                        <textarea
                            onChange={handleHintEdit}
                            value={hint}
                            placeholder="Word hint"
                            className={`my-roboto-regular font-size-16 text-area-border padding-all-14 width-260 height-145 position-absolute bg-color-grey color-black-custom border-radius-5`}/>
                        {/*单词数字提示*/}
                        {hint.length > 0 && <div
                            className={`${hint.length >= maxHintLength ? 'color-red' : 'color-grey'} width-57 height-23 border-radius-18 font-size-13 my-roboto-regular  bg-color-white position-absolute text-center display-flex-row display-flex-justify-content-center display-flex-align-items-center right-5 bottom-5`}>
                            {`${hint.length}/${maxHintLength}`}
                        </div>}
                    </div>
                    <div onClick={handleSubmit}
                         className={`${(isEmptyOrNullOrUndefined(word) || isEmptyOrNullOrUndefined(hint)) ? 'bg-color-grey-btn' : 'bg-btn-blue-color'} font-size-16 my-roboto-medium margin-top-14 width-260 height-43 border-radius-5 color-white margin-left-right-auto display-flex-row display-flex-align-items-center display-flex-justify-content-center`}>OK
                    </div>
                </div>

            </CustomPopup>
        )
    }
;
export default CreateWordDialog;